import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { ApicallService } from '../../services/apicall.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import * as fs from 'file-saver';
import { FlashService } from '../../services/flash.service';
import { PermissionService } from '../../services/permission.service';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';

@Component({
  selector: 'app-custom-dialog-data',
  templateUrl: './custom-dialog-data.component.html',
  styleUrls: ['./custom-dialog-data.component.scss'],
})
export class CustomDialogDataComponent implements OnInit {

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  validationCheck: boolean = true;
  loading: boolean =true;
  disableCycle: any = false;
  uploadingFile: boolean = false;
  deletingFile: boolean = false;
  selectedYear: number;
  years: number[] = [];  
  matrixDownloadStatus: boolean = false;
  yearValue: any;
  monthValue: any;
  typeValue: any;
  

 

  constructor(
    private dialogRef: MatDialogRef<CustomDialogDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apiCallService:ApicallService,
    private flashService: FlashService,
    public permissionService: PermissionService,
  ) { 
    this.data = data;
  } 


  filteredOptions: any;
  filterStations: any;
  feeCode:any;
  segFrom: any = '';
  segTo: any = '';
  addStationsDisabled: any = 'true';
wdsdwd
  ngOnInit() {
    if(this.data.type == "previewPdf"){
      this.loading = true;
    }
    if(this.data.type == "createCampaign" || this.data.type == "createPLBCampaign"){
      const cycleparams = {
        param: '',
        action: '/utility/get_recurring_code'
      }
      this.apiCallService.triggerService(cycleparams).subscribe(res=>{
        if(res.response_code == 1){
          this.data.cyclesList = res.data.map(elm=>({
            'value': elm['code'],
            'viewValue': elm['name'],
          }));
        }
      })
      const yearparams = {
        param: '',
        action: '/utility/get_finacial_year'
      }
      this.apiCallService.triggerService(yearparams).subscribe(res=>{
        if(res.response_code == 1){
          this.data.finacialyearlist = res.data.map(elm=>({
            'viewValue': elm['financial_year'],
          }));
        }
      })

      const incentiveparams = {
        param: '',
        action: '/utility/get_incentive_type_for_campaign'
      }
      this.apiCallService.triggerService(incentiveparams).subscribe(res=>{
        if(res.response_code == 1){
          this.data.campaignTypeList = res.data.map(elm=>({
            'value': elm['id'],
            'viewValue': elm['name'],
          }));
        }
      })

      const feecodeparams = {
        param: '',
        action: '/campaign/get_feecode'
      }
      this.apiCallService.triggerService(feecodeparams).subscribe(res=>{
        if(res.response_code == 1){
          this.filteredOptions = res.data.map(elm=>({
            'value': [elm['id'],elm['fee_code']],
            'viewValue': elm['fee_code'],
          }))
          this.data.feeCodeArrayList = this.filteredOptions;
        }
      })

      const stationparams = {
        param: '',
        action: '/utility/get_station_list'
      }

      this.apiCallService.triggerService(stationparams).subscribe(res=>{
        if(res.response_code == 1){
          this.filterStations = res.data.map(elm=>({
            'value': elm['station_code'],
            'viewValue': elm['station_code']
          }))
          this.data.segFromArray = this.filterStations;
          this.data.segToArray = this.filterStations;
        }
      })

      this.selectedYear = new Date().getFullYear();
      for (let year = this.selectedYear; year >= 2013; year--) {
        this.years.push(year);
      }

      this.data.campaign_sub_type_list = [
        { value: '0', viewValue: 'Baggage and Other' },
        { value: '1', viewValue: 'Meal' },
        { value: '2', viewValue: 'Seat' }
      ];
    }
  }

  
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  private _filter(array, value: string) {
    const filterValue = value.toLowerCase();
    return array.filter(option => option.viewValue.toLowerCase().includes(filterValue));
  }

  feeCodeFilter(data){
    this.data.feeCodeArrayList = this._filter(this.filteredOptions,data);
  }

  segFromFilter(data){
    this.data.segFromArray = this._filter(this.filterStations,data);
    this.enabledAddDisabledButton();
  }

  segToFilter(data){
    this.data.segToArray = this._filter(this.filterStations,data);
    this.enabledAddDisabledButton();
  }

  onFeeCodeSeleted(data){
    if(this.feeCodeExist(this.data.feeCodeList, data.option.value[1])){
      this.feeCode = data.option.value[1];
      this.feeCode = '';
      return;
    }else{
      this.data.feeCodeList.push(data.option.value);
    }
    this.feeCode = data.option.value[1];
    this.feeCode = '';
  }

  feeCodeExist( feeCodeList, value) {
    return feeCodeList.some(function(el) {
      return el[1] === value;
    }); 
  }

  segmentExist(stationsList,segFrom, segTo){
    return stationsList.some(function(x) {
      return x[0] === segFrom && x[1] === segTo;
    });
  }

  stationExist(station){
    return this.filterStations.some(function(x) {
      return x.value === station;
    });
  }

  checkStation(segFrom, segTo){
    if(segFrom == segTo){
      return true;
    }
    return false;
  }

  onSegFromSelected(data){
    this.enabledAddDisabledButton();
  }

  onSegToSelected(data){
    if(this.checkStation(this.segFrom, data.option.value)){
      this.segTo = '';
      return;
    }
    if(this.segmentExist(this.data.stationsList, this.segFrom, data.option.value)){
      this.segTo = '';
      return;
    }
    this.enabledAddDisabledButton();
  }

  public displayNull(){
    return null
  }

  addStations(){
    this.data.stationsList.push([this.segFrom]);
    this.data.stationsList[this.data.stationsList.length-1].push(this.segTo);
    this.segFrom = '';
    this.segTo = '';
    this.enabledAddDisabledButton();
  }

  removeStation(index){
    this.data.stationsList.splice(index, 1);
    this.segTo = '';
    this.segFrom = '';
    this.enabledAddDisabledButton();
  }

  removeValue(index){
    this.data.feeCodeList.splice(index, 1);
    this.feeCode = '';
  }
  
  close(){
    this.dialogRef.close(true);
  }

  cycleChange(data){
  }

  validatecampaignName(value) {
    // this.data.GroupInInvoice = value.replace(/^[a-zA-Z0-9]+$/g, "");
    this.data.campaignName = value.replace(/[^a-zA-Z0-9\-_ '|\\]/g, "");
  }

   validateFeeCodes(value) {
    // this.data.GroupInInvoice = value.replace(/^[a-zA-Z0-9]+$/g, "");
    this.data.campaignName = value.replace(/[^a-zA-Z0-9\-_'|\\]/g, "");
  }

  subTypeChange(data){}

  campaignTypeChange(value){
    this.data.is_plb = "NO";
    this.data.campaign_sub_type = "0";
    // if(value == 1){
    //   this.data.cycle =  0;
    //   this.disableCycle = true;
    // }else{
    //   this.disableCycle = false;
    // }
  }

  changeSegment(data){
    if(data.value == "YES"){
      this.segFrom = '';
      this.segTo = '';
      this.data.stationsList = [];
    }
  }

  enabledAddDisabledButton(){
    if(this.segFrom.length>0 && this.segTo.length>0 && this.stationExist(this.segFrom) == true && this.stationExist(this.segTo) == true){
      this.addStationsDisabled =  false;
    }else{
      this.addStationsDisabled =  true;
    }
  }

  fileNameChange(filename){
    if((new RegExp('.csv')).test(filename)){
      this.validationCheck = false;
    }else{
      this.validationCheck = true;
    }
  }

  downloadCertificate(data, name){
    fs.saveAs(data, name);
  }

  downloadReport(data, name){
    this.flashService.show("Please wait downloading file.", 5000, 'success');
    this.downloadCertificate(data, name);
  }

  getProcess(event){
    this.loading = event.loaded < event.total;
  }

  selectFiles(event){
    this.uploadingFile = true;
    if(event.target.files.length == 0){
      this.data.selectFile = null;
      return;
    }
    // console.log('Select agent')
    this.data.fileUpdate = false;
    this.data.selectFile = event.target.files;
    // console.log('upload file',this.data.selectFile);
    if (this.permissionService.getPermission(['/agent/save_file'])) {
      this.apiCallService.sendAgentFile(this.data.selectFile).subscribe((data: any)=>{
        if(data.response_code == 1){
          this.flashService.show(data.response_text, 5000, 'success');
          this.data.fileUrl = data.data['fileUrl'];
          this.data.fileName = data.data['fileName'];
          this.data.fileUpdate = true
        }else{
          this.flashService.show(this.apiCallService.getValidationArray(data), 5000, 'warning');
        }
        this.uploadingFile = false;
      })
    }
    if (this.permissionService.getPermission(['/user/save_file'])) {
      this.apiCallService.sendUserFile(this.data.selectFile).subscribe((data: any)=>{
        if(data.response_code == 1){
          this.flashService.show(data.response_text, 5000, 'success');
          this.data.fileUrl = data.data['fileUrl'];
          this.data.fileName = data.data['fileName'];
          this.data.fileUpdate = true
        }else{
          this.flashService.show(this.apiCallService.getValidationArray(data), 5000, 'warning');
        }
        this.uploadingFile = false;
      })
    }
  }

  pushFile(event, $dir_name){
    this.uploadingFile = true;
    if(event.target.files.length == 0){
      this.data.selectFile = null;
      return;
    }
    // console.log('Dir name',$dir_name)
    // console.log('event',event.target.files)
    this.matrixDownloadStatus = true;
    this.data.fileUpdate = false;
    this.data.selectFile = event.target.files;
    this.apiCallService.pushFile(this.data.selectFile, $dir_name).subscribe((data: any)=>{
      if(data.response_code == 1){
        this.flashService.show(data.response_text, 5000, 'success');
        this.data.fileName = data.data;
        this.data.fileUpdate = true
      }else{
        this.flashService.show(this.apiCallService.getValidationArray(data), 5000, 'warning');
      }
      this.uploadingFile = false;
      this.matrixDownloadStatus = false;
    })
  }

  deletePushedFile(filename, dir_name){
    this.deletingFile = true;
    this.data.fileUpdate = false;
    const param = {
      file_name: filename,
      dir_name: dir_name
    }
    // console.log(param)
    const params = {
      param: param,
      action: '/user/delete_push_file'
    }
    this.apiCallService.triggerService(params).subscribe(data=>{
      if(data.response_code == 1){
        this.flashService.show(data.response_text, 5000, 'success');
        this.data.selectFile = null;
        this.data.fileUpdate = false;
        this.data.fileName = '';
      }else{
        this.flashService.show(this.apiCallService.getValidationArray(data), 5000, 'warning');
        this.data.fileUpdate = true;
      }
      this.deletingFile = false;
    })
  }

  downloadFile(data, name){
    fs.saveAs(data, name);
  }


  deleteFile(data){
    this.deletingFile = true;
    this.data.fileUpdate = false;
    const param = {
      file_name: data
    }
    let params;
    if (this.permissionService.getPermission(['/agent/delete_file'])) {
      params = {
        param: param,
        action: '/agent/delete_file'
      }
    }
    if (this.permissionService.getPermission(['/user/delete_file'])) {
      params = {
        param: param,
        action: '/user/delete_file'
      }
    }
    this.apiCallService.triggerService(params).subscribe(data=>{
      if(data.response_code == 1){
        this.flashService.show(data.response_text, 5000, 'success');
        this.data.selectFile = null;
        this.data.fileUpdate = false;
        this.data.fileName = '';
        this.data.fileUrl = null;
      }else{
        this.flashService.show(this.apiCallService.getValidationArray(data), 5000, 'warning');
        this.data.fileUpdate = true;
      }
      this.deletingFile = false;
    })
  }

  getUrl(path, filename){
    let params;
    const param = {
      path: path,
      filename: filename
    }
    if (this.permissionService.getPermission(['/user/get_url'])) {
      params = {
        param: param,
        action: '/user/get_url',
      };
    }
    if (this.permissionService.getPermission(['/agent/get_url'])) {
      params = {
        param: param,
        action: '/agent/get_url',
      };
    }
    this.apiCallService.triggerService(params).subscribe((data) => {
      if (data.response_code == 1) {
        if(data.data == undefined){
          this.flashService.show("Can't find file.", 5000, 'warning');
        }else{
          this.flashService.show("Please wait downloading file.", 5000, 'success');
          this.downloadCertificate(data.data, filename);
        }
      }
    })
  }

  // cache Remove start
  cacheDropdowns: any = [
    { value: 'Monthly', viewValue: "Monthly" },
    { value: 'Public', viewValue: "Public" },
  ];

  monthDropdowns: any = [
    { value: 'jan', viewValue: "January" },
    { value: 'feb', viewValue: "February" },
    { value: 'mar', viewValue: "March" },
    { value: 'apr', viewValue: "April" },
    { value: 'may', viewValue: "May" },
    { value: 'jun', viewValue: "June" },
    { value: 'jul', viewValue: "July" },
    { value: 'aug', viewValue: "August" },
    { value: 'sep', viewValue: "September" },
    { value: 'oct', viewValue: "October" },
    { value: 'nov', viewValue: "November" },
    { value: 'dec', viewValue: "December" },
  ];
  yearDropdowns: any = [
    { value: '2021', viewValue: "2021" },
    { value: '2022', viewValue: "2022" },
    { value: '2023', viewValue: "2023" },
    { value: '2024', viewValue: "2024" },
    { value: '2025', viewValue: "2025" },
    { value: '2026', viewValue: "2026" },
    { value: '2027', viewValue: "2027" }
  ];

  yearChange(data) {
    this.yearValue = data;
  }
  monthChange(data) {
    this.monthValue = data;
  }
  schemaType(data) {
    this.typeValue = data;
  }
  // ----------Clear cache end-------------


  updateData(status){
    this.data['status'] = status;
  }
}